import * as types from "./actionTypes";

export function setConfigType(type) {
  return { type: types.SET_FORM_CONFIG_TYPE, payload: { type } };
}
export function updateFormConfig(payload) {
  return { type: types.UPDATE_FORM_CONFIG, payload };
}
export function updateEntireFormConfig(payload) {
  return { type: types.UPDATE_ENTIRE_FORM_CONFIG, payload };
}
